import React from 'react';

const CartaXIcon = () => (
  <svg data-testid="carta-x-icon" xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 243.38 268.54">
    <path d="M154.74 130.16L237.74 0h-65.72l-50.33 78.57L71.36 0H5.63l83 130.16L0 268.54h66.48l55.21-86.57 55.21 86.57h66.48zM227.13 5.82l-75.85 118.93-26.13-40.79 50-78.14zm-75.85 129.74l81.41 127.16h-52.6l-54.95-86.16z" />
  </svg>
);
export { CartaXIcon };
